import { get, post } from './common'

export namespace admin {
  export function login(username: string, password: string) {
    return post<ApiTypes.DataResult<any>>('/admin/login', {}, { username, password })
  }

  export function getUserList(userCode: string) {
    return get<ApiTypes.DataResult<any>>('/admin/user/list', { userCode })
  }

  export function giftUserVip(userCode: string, days: number) {
    return post<ApiTypes.DataResult<any>>('/admin/user/gift/vip', {}, { userCode, days })
  }

  export function getUserVipRecord(userCode: string) {
    return get<ApiTypes.DataListResult<ServerData.UserVipRecord[]>>('/admin/user/vip/list', {
      userCode,
    })
  }

  export function cancelVip(vipId: number) {
    return post<ApiTypes.DataResult<any>>('/admin/user/vip/cancel', {}, { vipId })
  }

  export function addSaleSlug(name: string) {
    return post<ApiTypes.DataResult<any>>('/admin/sale/slug/add', {}, { name })
  }

  export function getSaleSlugList() {
    return get<
      ApiTypes.DataResult<{
        list: ServerData.SaleSlug[]
      }>
    >('/admin/sale/slug/list', {})
  }

  export function deleteSaleSlug(slugId: string) {
    return post<ApiTypes.DataResult<any>>('/admin/sale/slug/delete', {}, { slugId })
  }
}
